import EditTemplate from "../_templates/EditTemplate";
import { tournamentSchema } from "../../../schemas/tournament.schema";
import { getTournament, updateTournament } from "../../../api/tournament.api";

export default function EditTournament() {
  return (
    <EditTemplate
      title="Edit Tournament"
      schema={tournamentSchema}
      fetchFn={getTournament}
      updateFn={updateTournament}
      redirectPath="/cricket/tournaments"
    />
  );
}
